import React from 'react'
import styled, { css } from 'styled-components'

import { ButtonUnstyled } from 'components/Button'
import { ellipsis } from 'polished'

export interface OptionProps extends React.ButtonHTMLAttributes<any> {
  children?: React.ReactNode
  value?: string
  active?: boolean
}
const Option = styled(ButtonUnstyled)<OptionProps>(
  ({ theme, active }) => css`
    ${ellipsis()};

    display: block;
    width: 100%;
    min-width: 150px;

    margin: 0;
    padding: 8px 16px;

    background-color: ${theme.colors.background.secondary[1]};

    color: ${active
      ? theme.colors.primaryTint[100]
      : theme.colors.foreground.secondary[2]};
    font-size: ${theme.fontSizes.smaller};
    font-weight: ${theme.fontWeights.regular};
    line-height: 1;
    text-align: left;

    cursor: pointer;
    transition: all ${theme.transitions.duration[1]};

    &:hover,
    &:focus {
      background-color: ${theme.colors.background.tertiary[1]};
      color: ${theme.colors.foreground.secondary[1]};
    }

    &.active {
      color: ${theme.colors.primaryTint[100]};
    }

    &:first-child {
      margin-top: 8px;
    }

    & ~ &:last-child {
      margin-bottom: 8px;
    }

    user-select: none;
  `
)

export default Option
